/* Cloofs – Werking voor de cloofs-secties: voortgangslijn van sliders, bijpassende producten ophalen en snel toevoegen.
   Geladen met defer, alleen waar zo'n sectie staat. Geen externe bibliotheken. Slepen met de muis: assets/cloofs-slider.js. */
(() => {
  if (window.cloofsSectionsLoaded) return;
  window.cloofsSectionsLoaded = true;

  const progress = (track) => {
    const holder = track.closest('.page-width') || track.parentElement;
    const bar = holder && holder.querySelector('[data-progress]');
    if (!bar) return;
    const total = track.scrollWidth || 1;
    const width = Math.min(100, (track.clientWidth / total) * 100);
    const left = Math.min(100 - width, (track.scrollLeft / total) * 100);
    bar.style.width = width + '%';
    bar.style.left = left + '%';
    bar.parentElement.hidden = width >= 99;
  };
  const initSliders = (root = document) => {
    root.querySelectorAll('[data-cloofs-slider]:not([data-ready])').forEach((track) => {
      track.setAttribute('data-ready', '');
      track.addEventListener('scroll', () => progress(track), { passive: true });
      window.addEventListener('resize', () => progress(track), { passive: true });
      progress(track);
    });
  };
  initSliders();
  document.addEventListener('shopify:section:load', (e) => initSliders(e.target));

  /* Pijltjes bij 'Maak de fit compleet': een kaart verder of terug */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fit-prev], [data-fit-next]');
    if (!btn) return;
    const wrap = btn.closest('.cloofs-fit');
    const track = wrap && wrap.querySelector('[data-cloofs-slider]');
    const item = track && track.querySelector('.cloofs-fit__item');
    if (!item) return;
    const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    track.scrollBy({ left: btn.hasAttribute('data-fit-next') ? step : -step, behavior: 'smooth' });
  });

  /* Bijpassende producten (Shopify product recommendations).
     Eerst data-url (aanvullend); leeg en data-fallback-url aanwezig: dan die (gerelateerd).
     Het element zelf is verborgen tot er producten zijn; daarom wordt de sectie-wrapper eromheen geobserveerd. */
  const fetchList = (url) => fetch(url)
    .then((r) => r.text())
    .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]'));
  class CloofsRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded || !this.dataset.url) return;
      this.dataset.loaded = '1';
      const load = () => fetchList(this.dataset.url)
        .then((list) => ((list && list.children.length) || !this.dataset.fallbackUrl ? list : fetchList(this.dataset.fallbackUrl)))
        .then((list) => {
          const target = this.querySelector('[data-recs]');
          if (list && target && list.children.length) {
            target.innerHTML = list.innerHTML;
            this.hidden = false;
            target.removeAttribute('data-ready');
            initSliders(this);
          } else {
            this.hidden = true;
          }
        })
        .catch(() => { this.hidden = true; });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
        }, { rootMargin: '600px 0px' });
        io.observe(this.hidden && this.parentElement ? this.parentElement : this);
      } else {
        load();
      }
    }
  }
  if (!customElements.get('cloofs-recommendations')) customElements.define('cloofs-recommendations', CloofsRecommendations);

  /* Snelweergave (popup) bij de +-knop: haalt ?view=cloofs-quick op, kleur/maat kiezen, toevoegen, drawer opent */
  const qv = () => document.getElementById('CloofsQuickView');
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let qvVariants = [];
  const qvFind = (box) => {
    const picked = [];
    box.querySelectorAll('[data-qv-option]').forEach((i) => { if (i.checked) picked[Number(i.dataset.qvOption)] = i.value; });
    return qvVariants.find((v) => v.options.every((o, k) => o === picked[k])) || null;
  };
  const qvUpdate = (box) => {
    const v = qvFind(box);
    const btn = box.querySelector('[data-qv-add]');
    const price = box.querySelector('[data-qv-price]');
    box.querySelectorAll('[data-qv-option]:checked').forEach((i) => {
      const lbl = box.querySelector(`[data-qv-selected="${i.dataset.qvOption}"]`);
      if (lbl) lbl.textContent = i.value;
    });
    /* maten die in de gekozen kleur niet leverbaar zijn doorstrepen */
    const colorIdx = 0;
    const color = box.querySelector(`[data-qv-option="${colorIdx}"]:checked`);
    box.querySelectorAll('[data-qv-option="1"]').forEach((i) => {
      const ok = qvVariants.some((x) => x.available && x.options[1] === i.value && (!color || x.options[0] === color.value));
      i.closest('.cloofs-qv__val').classList.toggle('is-unavailable', !ok);
    });
    if (!btn) return;
    if (v) {
      btn.dataset.variantId = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      if (price) price.innerHTML = (v.compare ? `<s class="cloofs-price__was">${v.compare}</s>` : '') + `<span class="cloofs-price__now">${v.price}</span>`;
      const track = box.querySelector('[data-qv-track]');
      if (track && v.media !== null && v.media !== undefined) track.scrollTo({ left: v.media * track.clientWidth, behavior: 'smooth' });
    } else {
      btn.disabled = true;
      btn.textContent = 'Niet beschikbaar';
    }
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-quick-view]');
    const dlg = qv();
    if (open && dlg) {
      e.preventDefault();
      const content = dlg.querySelector('[data-qv-content]');
      content.innerHTML = '<p class="cloofs-qv__loading">Laden…</p>';
      dlg.querySelector('[data-qv-title]').textContent = open.getAttribute('aria-label').replace(' snel bekijken', '');
      document.documentElement.classList.add('lock-scroll');
      dlg.showModal();
      fetch(open.dataset.quickView + (open.dataset.quickView.includes('?') ? '&' : '?') + 'view=cloofs-quick')
        .then((r) => r.text())
        .then((html) => {
          content.innerHTML = html;
          const data = content.querySelector('[data-qv-variants]');
          qvVariants = data ? JSON.parse(data.textContent) : [];
          content.scrollTop = 0;
          const track = content.querySelector('[data-qv-track]');
          const idx = content.querySelector('[data-qv-index]');
          if (track && idx) track.addEventListener('scroll', () => { idx.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1; }, { passive: true });
          qvUpdate(content);
        })
        .catch(() => { content.innerHTML = '<p class="cloofs-qv__loading">Kon het product niet laden. <a href="' + open.dataset.quickView + '">Bekijk het product</a>.</p>'; });
      return;
    }
    if (!dlg || !dlg.open) return;
    if (e.target === dlg || e.target.closest('[data-qv-close]')) { dlg.close(); return; }
    const nav = e.target.closest('[data-qv-prev], [data-qv-next]');
    if (nav) {
      const track = dlg.querySelector('[data-qv-track]');
      track.scrollBy({ left: nav.hasAttribute('data-qv-next') ? track.clientWidth : -track.clientWidth, behavior: 'smooth' });
      return;
    }
    const add = e.target.closest('[data-qv-add]');
    if (add && !add.disabled) {
      add.disabled = true;
      fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: 1 }] })
      })
        .then((r) => { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(() => { dlg.close(); document.dispatchEvent(new CustomEvent('ajaxProduct:added')); })
        .catch(() => { add.textContent = 'Lukt niet, probeer opnieuw'; })
        .finally(() => { add.disabled = false; });
    }
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches('[data-qv-option]')) return;
    qvUpdate(e.target.closest('[data-qv-product]'));
  });
  document.addEventListener('close', (e) => {
    if (e.target && e.target.id === 'CloofsQuickView') document.documentElement.classList.remove('lock-scroll');
  }, true);

  /* Snel toevoegen (alleen producten zonder maatkeuze) */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.quickAdd), quantity: 1 }] })
    })
      .then((r) => { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(() => {
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(() => {})
      .finally(() => { btn.disabled = false; });
  });
})();
